import { Box, Grid, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SpeechBubbleWrapper = styled(Grid)(({ theme }) => ({
  margin: theme?.spacing(1),
}));

export const SpeechBubblePaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "direction",
})(({ direction, theme }) => ({
  minHeight: "18px",
  position: "relative",
  background: direction === "sent" ? theme?.palette.blue.main : theme?.palette.surface.dark,
  borderRadius: "8px",
  padding: theme?.spacing(2),
  color: direction === "sent" ? "white" : "black",

  "&::after": {
    content: "''",
    position: "absolute",
    width: 0,
    height: 0,
    bottom: "-22px",
    left: direction === "sent" ? "100%" : 0,
    marginLeft: direction === "sent" ? "-58px" : "-13px",
    borderLeft: "18px solid transparent",
    borderRight: "53px solid transparent",
    borderTop: "60px solid",
    borderTopColor: direction === "sent" ? theme?.palette.blue.main : theme?.palette.surface.dark,
    transform: direction === "sent" ? "rotate(-25deg) scaleX(-1) scaleY(.9)" : "rotate(25deg) scaleY(.9)",
  },

  "& p": {
    position: "relative",
    zIndex: 2,
  },
}));

export const DetailsBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "direction",
})(({ direction, theme }) => ({
  textAlign: direction === "sent" ? "end" : "start",
  margin: `0 ${theme?.spacing(5)}`,
}));
